class ComponentSearch extends HTMLElement {
  constructor() {
    super();
    this.triggerBtn = document.querySelectorAll('.search-icon');
    this.drawer = document.querySelector('.search-drawer');
    this.drawerBody = this.querySelector('.search-drawer-body');
    this.closeBtn = this.querySelector('.search-drawer-close svg');
    this.input = this.querySelector('input[type="search"]');
    this.clearInput = this.querySelector('.clear');
    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.init();
  }

  init() {
    this.triggerBtn.forEach((btn) => {
      btn.addEventListener('click', this.openDrawer);
    });
    this.drawer.addEventListener('click', this.closeDrawer);
    this.closeBtn.addEventListener('click', this.closeDrawer);
    this.input.addEventListener('input', this.onInputType);
    this.clearInput.addEventListener('click', this.clearSearchInput);
    this.input.value = '';
  }

  openDrawer() {
    document.body.classList.add('overflow-hidden');
    this.classList.add('open');
  }

  closeDrawer(e) {
    if ((e.target === this.drawer) || (e.target === this.closeBtn)) {
      document.body.classList.remove('overflow-hidden');
      this.classList.remove('open');
    }
  }

  onInputType() {
    if (this.value.length > 0) {
      document.querySelector('component-search .clear').style.visibility = 'visible';
      document.querySelector('component-search button.submit').style.visibility = 'visible';
    } else {
      document.querySelector('component-search .clear').style.visibility = 'hidden';
      document.querySelector('component-search button.submit').style.visibility = 'hidden';
    }
  }

  clearSearchInput() {
    document.querySelector('component-search input[type="search"]').value = '';
    document.querySelector('component-search button.submit').style.visibility = 'hidden';
    this.style.visibility = 'hidden';
  }
}

export { ComponentSearch };